import React, { FC, useState } from 'react'
// import './styles.scss'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import Toggle from 'react-toggle'

// const checkIsMobile = window.innerWidth <= 599

export const CasesWorldMap: FC<{
  title?: string
  toggleNameLeft?: string
  toggleNameRight?: string
  dwChartIdLeft?: string
  dwChartIdRight?: string
}> = ({ title, toggleNameLeft, toggleNameRight, dwChartIdLeft, dwChartIdRight }) => {
  const [isViewWorld, setViewWorld] = useState<boolean>(false)

  return (
    <GraphicContainer id='CasesWorldMap'>
      {title && <h3>{title}</h3>}

      <div className='toggleWrapper'>
        <div className='center'>
        {toggleNameLeft && (
          <div className={'label ' + (!isViewWorld ? '' : 'off')}> {toggleNameLeft}</div>
        )}
          <div className='toggleContainer'>
            <Toggle
              defaultChecked={isViewWorld}
              icons={false}
              onChange={() => {
                setViewWorld(!isViewWorld)
              }}
            />
          </div>
          {toggleNameRight && (
            <div className={'label right ' + (isViewWorld ? '' : 'off')}>
              {toggleNameRight}
            </div>
          )}
        </div>
      </div>

      <div
        className='switchMap'
        style={{ position: 'relative', display: 'block' }}
      >
        <div
          style={{
            opacity: !isViewWorld ? '0' : '1.0',
            position: 'absolute',
            top: '0',
            zIndex: !isViewWorld ? 1 : 99,
            width: '100%',
          }}
        >
          <AutofitIFrame src={`//datawrapper.dwcdn.net/${dwChartIdRight}/`} />
          {/* <DataWrapperChart chartId='EQ9Ye' height={504} /> */}
        </div>
        <div
          style={{
            opacity: isViewWorld ? '0' : '1.0',
            position: 'relative',
            top: '0',
            zIndex: !isViewWorld ? 99 : 1,
            width: '100%',
          }}
        >
          <AutofitIFrame src={`//datawrapper.dwcdn.net/${dwChartIdLeft}/`} />
          {/* <DataWrapperChart chartId='TSG3x' height={504} /> */}
        </div>
      </div>
    </GraphicContainer>
  )
}
const GraphicContainer = styled.div<{ tenant?: string }>`
  h3 {
    /* max-width: 668px; */
    color: var(--text-color);
    margin: 0;
    font-size: 18px;
    line-height: 24px;
    padding-bottom: 20px;
    background: var(--site-background);
  }
`
